import {ComponentProps, Fragment, useEffect, useState} from "react";
import {RouteComponentProps, useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../apis/sampleDealerQuota";
import useAntTable from "../../utils/useAntTable";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import {SampleDealerQuotaTransactionTypeMapping} from "../../utils/constants";
import dayjs from "dayjs";
import {Button, Card, Modal, Space} from "antd";
import {useHistory} from "react-router-dom";
import styles from "./index.module.css";
import useFormModal from "../../utils/useFormModal";
import ModifyModal from "./component/ModifyModal";
import withAuth from "../../utils/withAuth";


type RouteParams = {
    id: string
}
const AddFragment = withAuth('add', Fragment);
const SubFragment = withAuth('sub', Fragment);

function SampleDealerQuotaDetail(props: RouteComponentProps<RouteParams>) {
    const id = useParams<RouteParams>().id;
    const [data, setData] = useState<any>({});
    const history = useHistory();
    const {loading: loadingGetData, run: runGetData} = useRequest(api.getDealerQuotasDetail, {
        manual: true,
        onSuccess(res) {
            setData(res.data.data[0] || {});
        }
    });

    const {
        tableProps,
        refresh,
        search,
        form
    } = useAntTable(api.getTradeRecords, {defaultParams: {dealerId: id}});

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.addTradeRecord,
        onOk() {
            setVisible(false);
            runGetData(id)
            refresh()
        }
    });

    const columns: StandardColumnsType = [
        {
            dataIndex: 'transactionType',
            title: '交易类型',
            render(v) {
                return SampleDealerQuotaTransactionTypeMapping[v]
            }
        },
        {
            dataIndex: 'orderNumber',
            title: '销售订单'
        },
        {
            dataIndex: 'sampleQuota',
            title: '样品额度'
        },
        {
            dataIndex: 'remark',
            title: '备注'
        },
        {
            dataIndex: 'createTime',
            title: '创建日期',
            render(v) {
                return v && dayjs(v).format('ll')
            }
        }
    ];

    useEffect(() => {
        if (id) {
            runGetData(id);
        }
    }, [id]);

    useEffect(() => {
        if (data.customerCode) {
            refresh();
        }
    }, [data.customerCode])

    const toolbar = (
        <div className={styles.Toolbar}>
            <Space>
                <p>样品额度:<span>{data.openingAmount}</span></p>
            </Space>
            <Space>
                <AddFragment>
                    <Button type={"link"} key={'add'} onClick={() => setVisible(true, {
                        amount: data.amount,
                        dealerId: data.dealerId,
                        transactionType: 10
                    })}>增加</Button>
                </AddFragment>
                <SubFragment>
                    <Button type={"link"} key={'sub'} onClick={() => setVisible(true, {
                        amount: data.amount,
                        dealerId: data.dealerId,
                        transactionType: 20
                    })}>减少</Button>
                </SubFragment>
                <Button type={"link"} key={'back'} onClick={() => history.goBack()}>返回</Button>
            </Space>
        </div>
    )


    return <PageHeaderLayout>
        <Card title={toolbar}>
            <StandardTable {...tableProps} submit={search.submit} columns={columns} form={form} showCard={false}/>
        </Card>
        <ModifyModal {...modalProps}/>
    </PageHeaderLayout>
}

export default SampleDealerQuotaDetail;
